// pp-calc-emplaye.js — Verificador de Emplaye (/pages/verificador-de-emplaye).
//
// POR QUÉ EXISTE
// En México es común que un rollo "de 800 pies calibre 60" traiga menos
// película de la que promete (o puro cartón de núcleo pesado). El método de
// verificación por peso ya vive en la guía del blog "¿Tu Emplaye es el que te
// Vendieron?" — este archivo lo vuelve calculadora. Los números y la fórmula
// son LOS MISMOS de la guía para que ambas piezas cuenten la misma historia:
//
//   PESO DEL PLÁSTICO (kg) ≈ (ANCHO in × LARGO ft × CALIBRE) ÷ 100 ÷ 5500
//
// que es la densidad del LLDPE (0.92 g/cm³) disfrazada de regla de dedo:
// gramos por metro = ancho_m × micras × 0.92.
//
// La aritmética vive aquí y no en el <script> de la sección porque así se
// prueba con node a secas en tests/calculadoras-logica.test.mjs, igual que
// pp-stats-filtros.js.
(function (root) {
  'use strict';

  var DENSIDAD_LLDPE = 0.92; // g/cm³ — película estirable estándar
  var MICRAS_POR_GAUGE = 0.254; // "cal. 60" ≈ 15 micras (60 × 0.254)
  var M_POR_FT = 0.3048;
  var M_POR_IN = 0.0254;

  function micrasDeCalibre(gauge) {
    return gauge * MICRAS_POR_GAUGE;
  }

  // Gramos de película por metro lineal de rollo.
  // ancho_m × (micras × 1e-6 m) × 920,000 g/m³ = ancho_m × micras × 0.92
  function gramosPorMetro(anchoM, micras) {
    return anchoM * micras * DENSIDAD_LLDPE;
  }

  // Analiza un rollo. Entradas ya normalizadas a:
  //   pesoRolloKg  — rollo completo tal como llegó
  //   pesoNucleoKg — el tubo de cartón vacío
  //   anchoM       — ancho de la película en metros
  //   micras       — espesor declarado
  //   largoPrometidoM — lo que dice la etiqueta/factura
  //   precio (opcional) — lo pagado por el rollo, MXN
  //
  // Devuelve null si las entradas no alcanzan para calcular.
  function analizarRollo(e) {
    if (!e) return null;
    var pesoRollo = num(e.pesoRolloKg);
    var pesoNucleo = num(e.pesoNucleoKg);
    var anchoM = num(e.anchoM);
    var micras = num(e.micras);
    var largoProm = num(e.largoPrometidoM);
    if (pesoRollo === null || pesoNucleo === null || anchoM === null || micras === null || largoProm === null) return null;
    if (pesoRollo <= 0 || anchoM <= 0 || micras <= 0 || largoProm <= 0 || pesoNucleo < 0) return null;

    var pesoPlasticoKg = pesoRollo - pesoNucleo;
    if (pesoPlasticoKg <= 0) return { error: 'nucleo_mayor' };

    var gPorM = gramosPorMetro(anchoM, micras);
    var metrosReales = (pesoPlasticoKg * 1000) / gPorM;
    var pesoTeoricoKg = (largoProm * gPorM) / 1000;
    var cumplimiento = metrosReales / largoProm; // 1.0 = exacto
    var faltantePct = (1 - cumplimiento) * 100; // positivo = te falta

    // Semáforo alineado a la tolerancia de la guía (±5–8% es aceptable):
    // dentro de 8% → consistente; 8–15% → dudoso; >15% → bandera roja.
    var veredicto = 'ok';
    if (faltantePct > 15) veredicto = 'rojo';
    else if (faltantePct > 8) veredicto = 'alerta';

    var r = {
      pesoPlasticoKg: pesoPlasticoKg,
      pesoTeoricoKg: pesoTeoricoKg,
      gramosPorMetro: gPorM,
      metrosReales: metrosReales,
      metrosFaltantes: Math.max(0, largoProm - metrosReales),
      cumplimientoPct: cumplimiento * 100,
      faltantePct: faltantePct,
      veredicto: veredicto
    };

    var precio = num(e.precio);
    if (precio !== null && precio > 0) {
      r.precioPorMetroReal = precio / metrosReales;
      r.precioPorMetroPrometido = precio / largoProm;
    }
    return r;
  }

  // ── Conversión de unidades de la UI ──────────────────────────────────────
  function anchoAMetros(valor, unidad) {
    var v = num(valor);
    if (v === null || v <= 0) return null;
    if (unidad === 'in') return v * M_POR_IN;
    return v / 100; // cm
  }

  function largoAMetros(valor, unidad) {
    var v = num(valor);
    if (v === null || v <= 0) return null;
    if (unidad === 'ft') return v * M_POR_FT;
    return v; // m
  }

  function espesorAMicras(valor, unidad) {
    var v = num(valor);
    if (v === null || v <= 0) return null;
    if (unidad === 'gauge') return micrasDeCalibre(v);
    return v; // micras
  }

  function pesoAKg(valor, unidad) {
    var v = num(valor);
    if (v === null || v < 0) return null;
    if (unidad === 'g') return v / 1000;
    return v; // kg
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcEmplaye = {
    DENSIDAD_LLDPE: DENSIDAD_LLDPE,
    micrasDeCalibre: micrasDeCalibre,
    gramosPorMetro: gramosPorMetro,
    analizarRollo: analizarRollo,
    anchoAMetros: anchoAMetros,
    largoAMetros: largoAMetros,
    espesorAMicras: espesorAMicras,
    pesoAKg: pesoAKg
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-emplaye]');
    if (!raiz) return;
    var C = window.PPCalcEmplaye;

    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    // Telemetría anónima de uso (fire-and-forget). El precio del rollo que la
    // gente reporta pagar es oro para conocer el mercado — pedido de Padrino
    // el 31-ago-2026. Sin PII; si falla, silencio.
    function telemetria(inputs, resultado) {
      try {
        var KEY = 'sb_publishable_48y6S7h2eQ-9uTF7pCNJNQ_Q0mz8VVX';
        fetch('https://dhygbnysealeblqorjts.supabase.co/functions/v1/calc-telemetria', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + KEY },
          body: JSON.stringify({ calculadora: 'emplaye', inputs: inputs, resultado: resultado })
        }).catch(function () {});
      } catch (_) { /* la telemetría jamás rompe la calculadora */ }
    }

    // El hint de micras junto al calibre se actualiza en vivo.
    var espesorInput = $('[name="espesor"]');
    var espesorUnidad = $('[name="espesor_unidad"]');
    var hintMicras = $('[data-hint-micras]');
    function pintarHint() {
      if (!hintMicras) return;
      if (espesorUnidad.value !== 'gauge') { hintMicras.textContent = ''; return; }
      var v = Number(espesorInput.value);
      hintMicras.textContent = v > 0 ? '≈ ' + (C.micrasDeCalibre(v)).toFixed(1) + ' micras' : '';
    }
    if (espesorInput) espesorInput.addEventListener('input', pintarHint);
    if (espesorUnidad) espesorUnidad.addEventListener('change', pintarHint);
    pintarHint();

    // conTelemetria: solo el submit explícito reporta; el recálculo en vivo
    // al editar campos no, para no llenar la tabla con teclazos intermedios.
    function correr(conTelemetria) {
      var f = new FormData(form);
      var entradas = {
        pesoRolloKg: C.pesoAKg(f.get('peso_rollo'), f.get('peso_unidad')),
        pesoNucleoKg: C.pesoAKg(f.get('peso_nucleo'), f.get('peso_unidad')),
        anchoM: C.anchoAMetros(f.get('ancho'), f.get('ancho_unidad')),
        micras: C.espesorAMicras(f.get('espesor'), f.get('espesor_unidad')),
        largoPrometidoM: C.largoAMetros(f.get('largo'), f.get('largo_unidad')),
        precio: f.get('precio')
      };
      var r = C.analizarRollo(entradas);
      pintarResultado(r, f);
      // El corte transversal: núcleo de cartón, tu película real y el
      // contorno punteado de lo prometido — el veredicto que se VE.
      var contRollo = raiz.querySelector('[data-calc-dibujo-rollo]');
      if (contRollo && window.PPCaja3D && window.PPCaja3D.dibujarRollo) {
        if (r && !r.error) {
          contRollo.hidden = false;
          var enPiesRollo = f.get('largo_unidad') === 'ft';
          var aUniRollo = function (mts) {
            var v = enPiesRollo ? mts / 0.3048 : mts;
            return v.toLocaleString('es-MX', { maximumFractionDigits: 0 }) + (enPiesRollo ? ' pies' : ' m');
          };
          window.PPCaja3D.dibujarRollo(contRollo, {
            micras: entradas.micras,
            metrosReales: r.metrosReales,
            metrosPrometidos: entradas.largoPrometidoM,
            etiquetaReal: ['tu película real', aUniRollo(r.metrosReales)],
            etiquetaProm: ['lo prometido', aUniRollo(entradas.largoPrometidoM)]
          });
          var pieRollo = document.createElement('p');
          pieRollo.className = 'pp-c3d__pie';
          pieRollo.textContent = 'Corte transversal a escala: el anillo dorado es tu película real; la línea punteada, el rollo que te prometieron.';
          contRollo.appendChild(pieRollo);
        } else {
          contRollo.hidden = true;
        }
      }
      if (conTelemetria && r && !r.error) {
        telemetria(
          { peso_rollo_kg: entradas.pesoRolloKg, peso_nucleo_kg: entradas.pesoNucleoKg, ancho_m: entradas.anchoM, micras: entradas.micras, largo_prometido_m: entradas.largoPrometidoM, precio_mxn: Number(entradas.precio) || null },
          { metros_reales: Math.round(r.metrosReales * 10) / 10, faltante_pct: Math.round(r.faltantePct * 10) / 10, veredicto: r.veredicto, precio_por_metro_real: r.precioPorMetroReal ? Math.round(r.precioPorMetroReal * 100) / 100 : null }
        );
      }
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr(true);
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    // Con el resultado ya visible, editar cualquier campo recalcula solo.
    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(false); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec, minimumFractionDigits: 0 });
    }

    function pintarResultado(r, f) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: necesitamos los dos pesos, el ancho, el calibre y el largo prometido, todos mayores a cero.</p>';
        return;
      }
      if (r.error === 'nucleo_mayor') {
        out.innerHTML = '<p class="pp-calc__error">El núcleo pesa igual o más que el rollo completo — revisa que ambos pesos estén en la misma unidad.</p>';
        return;
      }

      var enFt = f.get('largo_unidad') === 'ft';
      var aUnidad = function (m) { return enFt ? m / 0.3048 : m; };
      var unidadTxt = enFt ? 'pies' : 'metros';
      var largoPromM = window.PPCalcEmplaye.largoAMetros(f.get('largo'), f.get('largo_unidad'));

      var titulos = {
        ok: 'Tu rollo es consistente con lo que te vendieron',
        alerta: 'Tu rollo trae menos de lo prometido',
        rojo: 'Bandera roja: te está faltando mucha película'
      };
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--' + r.veredicto + '">';
      html += '<p class="pp-calc__veredicto-titulo">' + titulos[r.veredicto] + '</p>';
      html += '<p class="pp-calc__veredicto-dato">Película real estimada: <strong>' + fmt(aUnidad(r.metrosReales)) + ' ' + unidadTxt + '</strong> de los ' + fmt(aUnidad(largoPromM)) + ' prometidos (' + fmt(r.cumplimientoPct, 1) + '%).</p>';
      if (r.veredicto !== 'ok') {
        html += '<p class="pp-calc__veredicto-dato">Te faltan ≈ <strong>' + fmt(aUnidad(r.metrosFaltantes)) + ' ' + unidadTxt + '</strong> (' + fmt(r.faltantePct, 1) + '% del rollo).</p>';
      }
      html += '</div>';

      html += '<dl class="pp-calc__detalle">';
      html += par('Peso de la película (sin núcleo)', fmt(r.pesoPlasticoKg, 2) + ' kg');
      html += par('Peso teórico si el rollo fuera completo', fmt(r.pesoTeoricoKg, 2) + ' kg');
      html += par('Gramos de película por metro', fmt(r.gramosPorMetro, 2) + ' g/m');
      if (r.precioPorMetroReal) {
        html += par('Precio por ' + (enFt ? 'pie' : 'metro') + ' anunciado', '$' + fmt(enFt ? r.precioPorMetroPrometido * 0.3048 : r.precioPorMetroPrometido, 2));
        html += par('Precio por ' + (enFt ? 'pie' : 'metro') + ' que realmente pagaste', '$' + fmt(enFt ? r.precioPorMetroReal * 0.3048 : r.precioPorMetroReal, 2));
      }
      html += '</dl>';

      if (r.veredicto !== 'ok') {
        html += '<p class="pp-calc__nota">La tolerancia industrial normal es de ±5–8%. Documenta el pesaje con fotos y reclama a tu proveedor — o cámbiate a un emplaye que sí traiga lo que promete.</p>';
      }
      out.innerHTML = html;

      function par(t, v) { return '<div class="pp-calc__detalle-fila"><dt>' + t + '</dt><dd>' + v + '</dd></div>'; }
    }
  });
})();
